import { memo, useMemo, useState } from 'react';

import SearchBoxCompo from '../../../components/Comman/SearchBoxCompo';
import { filterTableRows } from '../utils/filterTableRows';
import { DashboardTable } from './DashboardTable';

const SEARCH_WRAP_STYLE = {
  padding: '10px 14px 0',
};

const SEARCH_BOX_STYLE = {
  marginBottom: 8,
  marginLeft: 0,
};

export const SearchableDashboardTable = memo(function SearchableDashboardTable({
  columns,
  rows,
  scrollable = false,
  getRowKey,
  placeholder = 'Search...',
}) {
  const [search, setSearch] = useState('');

  const filteredRows = useMemo(
    () => filterTableRows(rows, columns, search),
    [rows, columns, search],
  );

  return (
    <>
      <div style={SEARCH_WRAP_STYLE}>
        <SearchBoxCompo
          value={search}
          onChange={setSearch}
          placeholder={placeholder}
          style={SEARCH_BOX_STYLE}
        />
      </div>
      <DashboardTable
        columns={columns}
        rows={filteredRows}
        scrollable={scrollable}
        getRowKey={getRowKey}
      />
    </>
  );
});
